export enum BookmarkModuleAccessorLevel {
  User = 'user',
  Group = 'group',
}
